//
// File: sqlPArams.ts
// Description: Our common sql params used for filtering and sorting in the backend via api calls
// Copyright: Broadlume 2024
//

/**
 * Enum to represent the operators for SQL filters
 */
export enum SqlFilterOperator {
  Equals = 'e',
  NotEquals = 'ne',
  GreaterThan = 'gt',
  LessThan = 'lt',
  Like = 'like',
  ILike = 'ilike',
  In = 'in',
  NotIn = 'nin',
}

/**
 * Interface to wrap basic parameters for SQL filters
 */
export interface SqlFilterParameters {
  column: string;
  operator: SqlFilterOperator;
  value: string | number;
  isArray?: boolean;
}

/**
 * Enum to represent the sort direction for SQL queries
 */
export enum SqlSortDirection {
  Ascending = 'asc',
  Descending = 'desc',
  DESC = 'DESC',
  AESC = 'ASC',
}

/**
 * Interface to wrap basic parameters for SQL sort
 */
export interface SqlSortParameters {
  column: string;
  direction: SqlSortDirection;
}
